<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="title-box">
          <div class="title-box-right">
            订单支付>合约支付
          </div>
          <div class="title-box-right">
            <a-button @click="$router.go(-1)">取消支付</a-button>
          </div>
        </div>
      </template>
      <div class="form-box">

        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>付款钱包</span></a-col>
            <a-col :span="20">
              <MchChooseDialog style="width: 300px;" v-model="paramsData.mchName" @chooseDone="onMchChosen" mchType="1"/>
            </a-col>
          </a-row>
        </div>
        <!-- 钱包账号 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4">
              <span>钱包账号</span>
            </a-col>
            <a-col>
              <a-radio-group v-model="paramsData.accountNo" @change="changeAccount($event)">
                <a-radio-button v-for="(item, ind) in payerWalletList" :key="'payerWalletList' + ind"
                                :value="item.accountNo"
                                :disabled="!$authority('A2BalanceVisible') && item.accountClass == '6'">
                  <a-tag :color="item.accountClass == '0' ? 'green' : 'blue'">{{
                      item.accountClass == '0' ? '活期' : '冻结'
                    }}
                  </a-tag>
                  <span class="right">{{ item.accountNo }}</span>
                </a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
        </div>

        <!-- 支付方式 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4">
              <span>付款方式</span>
            </a-col>
            <a-col :span="20">
              <a-radio-group v-model="paramsData.payWay" default-value="5">
                <a-radio-button default value="5">合约支付</a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
        </div>

        <!-- 可使用余额 -->
        <div class="form-box-item">
          <a-row style="display: flex; align-items: center;">
            <a-col :span="4">
              <span>可用余额</span>
            </a-col>
            <a-col :span="4">
              <Balance :amount="avibaleBalanceA2" :align-right="false"></Balance>
            </a-col>
          </a-row>
        </div>


        <!-- 收款对象 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4">
              <span>收款人</span>
            </a-col>
            <a-col :span="20">
              <a-select placeholder="请选择收款人" v-model="paymentValue" @change="paymentChange($event)">
                <a-select-option v-for="item in paymentList" :key="item.id" :value="item.id">
                  <WalletInfo :account-name="item.oppAccountName" :account-no="item.oppAccountNo"
                              :bank-name="item.oppBankName" :bank-no="item.oppBankNo"
                              :show-account-no="false" :show-account-name="true"
                              :is-wallet="item.oppAccountType==='1'"
                              :show-balance="false"
                  ></WalletInfo>
                  <a-tag color="red" v-if="item.checkStatus === '0'">待审批</a-tag>
                </a-select-option>
              </a-select>
              <div class="payment-box" v-if="paymentValue">
                <a-descriptions :column="1" size="small" bordered>
                  <a-descriptions-item label="收款户名">{{ paramsData.oppAccountName }}</a-descriptions-item>
                  <a-descriptions-item label="收款账号">{{ paramsData.oppAccountNo }}</a-descriptions-item>
                  <a-descriptions-item label="开户银行">{{ paramsData.oppBankName }}</a-descriptions-item>
                  <a-descriptions-item label="开户行号">{{ paramsData.oppBankNo }}</a-descriptions-item>
                </a-descriptions>
              </div>
            </a-col>
          </a-row>
        </div>

        <div class="form-box-item">
          <a-row>
            <a-col :span="4">
              <span>支付金额</span>
            </a-col>
            <a-col :span="20">
              <input-balance v-model="paramsData.payAmount"
                             :max="maxPayAmount"
                             @blur="payAmountChange"
                             style="width: 300px;"
                             align-left></input-balance>
            </a-col>
          </a-row>
        </div>
        <div class="form-box-item">
          <a-row>
            <a-col :span="4">
              <span>交易摘要</span>
            </a-col>
            <a-col :span="20">
              <a-textarea v-model="paramsData.remark" :rows="1" :disabled="true" size="small" placeholder="请输入，如“税金”"></a-textarea>
            </a-col>
          </a-row>
        </div>

        <!-- 验证码 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4">
              <span>验证码</span>
            </a-col>
            <a-col :span="20">
              <payment-sms style="width:300px"
                           :verify-code.sync="paramsData.verifyCode"
                           :account-name="paramsData.accountName"
                           :account-no="paramsData.accountNo"
                           :pay-amount="paramsData.payAmount"
                           model-no="102208"
                           :mobile="mobile"
                           :channel-no="paramsData.channelNo"
                           :disabled="!paramsData.oppAccountNo || Number(paramsData.payAmount)<=0"
                           :qr-invitation-fn="qrcodeBusi"
              ></payment-sms>
            </a-col>
          </a-row>
        </div>
        <div class="form-box-item">
          <a-row>
            <a-col :span="4">
            </a-col>
            <a-col :span="20">
              <div
                  style="display: flex; flex-direction: column;align-items: start; justify-content: space-between; min-height: 100px;">
                <div style="display: flex; justify-content: space-between;">
                  <a-button type="primary"
                            :disabled="!paramsData.payAmount || !paramsData.oppAccountNo || !paramsData.verifyCode"
                            @click="onSubmitPay" icon="property-safety" style="width: 300px;">确认支付
                  </a-button>
                  <a-tooltip>
                    <template slot="title">
                      生成二维码,请本人确认
                    </template>
                    <a-button type="link"
                              v-if="paramsData.payAmount && paramsData.oppAccountNo && !paramsData.verifyCode"
                              @click="qrcodeBusi" icon="qrcode" style="width: 50px;">
                    </a-button>
                  </a-tooltip>

                </div>
                <a-space></a-space>
                <a-button type="link" @click="$router.go(-1)" icon="clock-circle" style="width: 300px;">历史交易
                </a-button>
              </div>
            </a-col>
          </a-row>
        </div>

      </div>
      <!-- 确认支付弹框 -->
      <a-modal :visible="isShowConfirmDialog" :centered="true" @ok="onConfirmDialog"
               :ok-text="isQrBusi?'生成二维码':'提交'"
               @cancel="cancelConfirmDialog">
        <p>
          <a-descriptions title="支付信息确认" bordered :column="2">
            <a-descriptions-item label="金额">
              <Balance :amount="paramsData.payAmount" prefix="" suffix="元"></Balance>
            </a-descriptions-item>
            <a-descriptions-item label="方式">
              <a-tag v-if="paramsData.payWay==='1'" color="blue">余额支付</a-tag>
              <a-tag v-else-if="paramsData.payWay==='2'" color="purple">融资支付</a-tag>
              <a-tag v-else-if="paramsData.payWay==='4'" color="cyan">清分支付</a-tag>
              <a-tag v-else-if="paramsData.payWay==='5'" color="cyan">合约支付</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="说明"><span style="color: #FF9500;font-size: 17px">{{ contract_pay_msg }}</span></a-descriptions-item>
          </a-descriptions>
          <a-descriptions title="收款人信息" bordered :column="1">
            <a-descriptions-item label="户名">
              {{ paramsData.oppAccountName }}
            </a-descriptions-item>
            <a-descriptions-item label="账号">
              {{ paramsData.oppAccountNo }}
            </a-descriptions-item>
            <a-descriptions-item label="开户行">
              {{ paramsData.oppBankName }}
            </a-descriptions-item>
            <a-descriptions-item label="交易备注" >
              {{ paramsData.remark }}
            </a-descriptions-item>
          </a-descriptions>
        </p>
      </a-modal>
      <QRConfirm :url="qrConfirmUrl" :display.sync="qrConfirmShow" busi_intro="合约支付" :username="paramsData.accountName"></QRConfirm>
    </a-card>
  </div>
</template>
<script>
import MchChooseDialog from "@/view/components/ChooseDialog/MchChooseDialog.vue";
import Balance from '@/view/components/Balance.vue'
import CountdownBtn from "@/view/components/CountdownBtn.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import InputBalance from "@/view/components/InputBalance.vue";
import PaymentSms from "@/view/components/PaymentSms.vue";
import QRConfirm from "@/view/components/QRConfirm.vue";

const paramsData = {
  // 所属机构
  departmentId: "",
  // 渠道编号
  channelNo: "",
  // 应用编号
  appNo: "",
  //	电商名称
  mchName: "",
  //	电商编号
  mchNo: "",
  // 	支付方式
  payWay: "",
  // 订单类型
  orderType: "1",
  //支付协议选择
  agreement: "",
  // 	付款账号/电商A1账号
  accountNo: "",
  // 付款户名/电商户名
  accountName: "",
  // 电商A2账号
  accountNoA2: "",
  // 贷款申请账号
  accountNoSq: "",
  // 贷款申请户名
  accountNameSq: "",
  // 	收款账户类型
  oppAccountType: "",
  // 	收款账号
  oppAccountNo: "",
  // 	收款户名
  oppAccountName: "",
  // 	收款行号
  oppBankNo: "",
  // 收款行名
  oppBankName: "",
  // 	验证码
  verifyCode: "",
  //支付金额
  payAmount: "",
  // 摘要
  remark: "",
  accountNoSettling: '',//待清算账号
  accountNameSettling: '',//待清算户名
};
export default {
  name: "AddPaymentOrders",
  components: {
    QRConfirm,
    PaymentSms,
    InputBalance,
    WalletInfo,
    MchChooseDialog,
    Balance,
    CountdownBtn
  },
  data() {
    return {
      contract_pay_msg: "",
      qrConfirmUrl: "",
      qrConfirmShow: false,
      isShowWaring: false,
      orderTypeDict: [
        {label: "支付MCN", value: "1"},
        {label: "支付主播", value: "2"},
        {label: "支付厂家", value: "3"},
        {label: "其他", value: "9"},
      ],
      // 页面参数
      paramsData,
      showDetail: false,
      treeData: [],
      // 表示调电商信息page
      selectType: "1",
      // 是否显示弹框
      isShowTableDialog: false,
      // 可用余额
      avibaleBalanceA1: 0,
      avibaleBalanceA2: 0,
      //贷款总额度
      totalLoan: "",
      // 可贷额度
      currentLoan: 0,
      // 累计已用额度
      accumulatedUsed: "",
      // 待清算金额
      toSettle: 0,
      // 客户编号
      custnum: "",
      // 收款对象数组
      paymentList: [],
      paymentValue: undefined,
      count: 0,
      codeVisible: true,
      timer: null,
      currentCode: "",
      isShowLoanPay: true,
      isShowConfirmDialog: false,
      isQrBusi: false,
      confirmSuccess: false,
      mobile_mch: "",
      mobile_sq: "",
      payerWalletList: [],
      clearAccount: [],
      clearAccountNum: '',
      royalty: 0,//选中电商的代销提成
      isSelectedControlMch: false
    };
  },

  watch: {},
  computed: {
    mobile() {
      if (this.paramsData.payWay === "2") {
        return this.mobile_sq
      } else {
        return this.mobile_mch
      }
    },

    maxPayAmount() {
        return this.avibaleBalanceA2
    }
  },
  mounted() {
    this.paramsData.departmentId = this.$session.getItem("companyId");
    this.getEcList()
  },
  methods: {
    async getEcList() {
      let data = {
        pageNo: 1,
        pageSize: 10,
      }
      data.obj = {
        mchNo: this.$route.query.mchNo || this.paramsData.mchNo
      }
      let res = await this.api.getEcListApi(data)
      if (res.code === 200) {
        await this.onMchChosen(res.data.records[0])
      } else {
        this.$message.error(res.info)
      }
    },

    changeAccount(event) {
      // 获取余额
      this.getAvibaleBalance()
      this.getBaseConfig()

    },

    async getBaseConfig() {

      const records = await this.api.findConfigApi(["contract_pay_remark", "pay_msg"]);
      if (records.code !== 200) {
        this.$message.warning(records.info);
        return;
      }
      this.paramsData.remark = records.data?.contract_pay_remark?.constValue ?? '税金';
      try {
        const payMsgConstValue = JSON.parse(records.data?.pay_msg?.constValue || '{}');
        this.contract_pay_msg = payMsgConstValue?.[this.paramsData.accountNoA2] ?? payMsgConstValue?.default ?? '';
      } catch (e) {
        console.error('解析 pay_msg.constValue 失败', e);
        this.contract_pay_msg = '';
      }

      console.log("contract_pay_remark", this.paramsData.remark);
      console.log("contract_pay_msg", this.contract_pay_msg);
    },

    async onMchChosen(mch) {
      //  如果选中的是可控电商，隐藏融资支付按钮，默认选中余额支付
      this.isSelectedControlMch = mch.mchType === '0' ? true : false
      //代销提成
      this.royalty = mch.royalty / 100
      this.clearAccountNum = mch.accountNoA2
      // 电商名称
      this.paramsData.mchName = mch.mchName;
      // 电商编号
      this.paramsData.mchNo = mch.mchNo;
      //付款户名/电商户名
      this.paramsData.accountName = mch.accountName;
      this.paramsData.accountNo = mch.accountNoA2;

      // 电商A2账号
      this.paramsData.accountNoA2 = mch.accountNoA2;
      this.paramsData.channelNo = mch.channelNo;
      this.paramsData.appNo = mch.appNo;
      // 客户编号
      this.custnum = mch.custnum;
      let accountA2Data = {
        accountClass: '6',
        accountNo: mch.accountNoA2
      }
      this.payerWalletList[0] = accountA2Data

      this.paramsData.payWay = "5";
      // 查询当前余额
      await this.getAvibaleBalance();
      // 查询协议
      await this.getPaymentList();
      await this.getBaseConfig();

    },

    // 获取可使用余额
    async getAvibaleBalance() {
      let data = {};
      data.channel_no = this.paramsData.channelNo;
      data.account_no = this.paramsData.accountNoA2;
      data.relation_acct = 1;
      let res = await this.api.avibaleBalanceApi(data);
      if (res.code == 200) {
        this.mobile_mch = res.data.mobile;
        let acctListA2 = res.data.detail_list.find(
            (acct) => acct.account_no === this.paramsData.accountNoA2
        );
        console.log("acctListA2",acctListA2)
        this.avibaleBalanceA2 = acctListA2?.cur_balance || 0;
      } else {
        return this.$message.error(res.info);
      }
    },

    async payAmountChange() {
      if (this.paramsData.payWay === "1") {
        //计算服务费
        const res = await this.api.getMchPayCalFeeApi({
          mchNo: this.paramsData.mchNo,
          amount: this.paramsData.payAmount
        })
        if (res.code !== 200) {
          this.paramsData.payFee = 0
        } else {
          this.paramsData.payFee = res.data.toFixed(2)
        }
      }
    },
    //余额支付/融资支付/协议支付
    async confirmPay() {
      let data = this.preparePaymentParams();
      let res = await this.api.orderPayApi(data);
      if (res.code == 200) {
        this.$message.success(res.info);
        this.$router.push({name: "contractPay"});
      } else {
        return this.$error({
          title: '支付失败',
          content: res.info,
        });
      }
    },

    preparePaymentParams() {
      this.paramsData.payAmount = Number(this.paramsData.payAmount);
      return JSON.parse(JSON.stringify(this.paramsData));
    },

    //余额支付/融资支付/协议支付暂存
    async ConfirmQRPush() {
      let data = this.preparePaymentParams();
      const res = await this.api.custOpenAccTaskSave({
        channelNo: data.channelNo,
        appNo: data.appNo,
        taskType: 15,
        name: data.accountName,
        mobile: this.mobile,
        cardNo: data.accountNo,
        reqData: data,
        exData: {
          "付款账户": data.accountName,
          "付款账号": data.accountNo,
          "金额": `￥${data.payAmount.toFixed(2)}元`,
          "收款账户": data.oppAccountName,
          "收款账号": data.oppAccountNo,
        }
      });

      if (res.code == 200) {
        this.confirmshow = false;
        this.qrConfirmUrl = res.data
        this.qrConfirmShow = true
      } else {
        return this.$error({
          title: '操作失败',
          content: res.info,
        });
      }
    },
    onSubmitPay() {

      if (!this.paramsData.payAmount) {
        return this.$message.error("请输入支付金额")
      }
      if (this.paramsData.verifyCode === "") {
        return this.$message.error("请填写验证码");
      }
      this.isQrBusi = false
      this.isShowConfirmDialog = true
    },

    qrcodeBusi() {
      if (!this.paramsData.mchNo) {
        return this.$message.error("请选择商户")
      }
      if (!this.paramsData.payAmount) {
        return this.$message.error("请输入支付金额")
      }
      this.isQrBusi = true
      this.isShowConfirmDialog = true
    },

    // 弹框确定按钮
    onConfirmDialog() {
      // 暂时验证成功
      this.confirmSuccess = true;
      if (this.confirmSuccess) {
        // 调用支付接口
        if (this.isQrBusi) {
          this.ConfirmQRPush();
        } else {
          this.confirmPay();
        }
      }
      // 关闭弹框
      this.isShowConfirmDialog = false;
      this.confirmSuccess = false;
    },
    // 弹框取消按钮
    cancelConfirmDialog() {
      this.isShowConfirmDialog = false;
    },

    // 获取支付协议信息
    async getPaymentList() {
      let data = {};
      data.pageNo = 1;
      data.pageSize = 10000;
      data.obj = {}
      if (this.paramsData.mchNo) {
        data.obj.mchNo = this.paramsData.mchNo;
      } else {
        return this.$message.error("请首先填写商户编号");
      }
      // 协议
      let res = await this.api.getPayProtocolListApi(data);
      if (res.code === 200) {
        this.paymentList = res.data.records;
        // 默认选中第一个已审批的收款人
        let defaultOppAcct = this.paymentList.find((item) => item.checkStatus === '1')
        this.paymentValue = defaultOppAcct?.id
        this.paymentChange(this.paymentValue)
      }
    },

    //  选中付款对象的回调
    paymentChange(event) {
      let value = event;
      let paymentData = this.paymentList.reduce((acc, item) => {
        if (item.id == value) {
          acc = JSON.parse(JSON.stringify(item));
        }
        return acc;
      }, {});
      // 回显收款对象信息
      this.paramsData.oppAccountType = paymentData.oppAccountType;
      this.paramsData.oppAccountNo = paymentData.oppAccountNo;
      this.paramsData.oppAccountName = paymentData.oppAccountName;
      this.paramsData.oppBankNo = paymentData.oppBankNo;
      this.paramsData.oppBankName = paymentData.oppBankName;
      this.paramsData.orderType = paymentData.orderType;
      //支付方式为融资支付，并且选中收款对象为未审批时，给出提示
      if (this.paramsData.payWay === '2' && paymentData.checkStatus === '0') {
        this.$warning({
          title: "提示",
          content: '收款人未审批，请联系核心企业！',
          centered: true

        })
      }

    },
  },
};
</script>

<style lang="less" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
}

.form-box {
  padding: 50px;

  .form-box-item {
    margin-bottom: 20px;

    .up,
    .down {
      cursor: pointer;
    }

    .up {
      transform: rotate(-180deg);
    }

    .ant-select {
      min-width: 300px;
    }

    .ant-input {
      max-width: 300px;
    }

    .ant-input-number {
      width: 300px;
    }


    .link_area {
      display: inline-block;
      width: 300px;
    }

    .ant-input-group-wrapper {
      width: 300px;
    }

    .clear-item {
      border: 1px solid #e5e5e5;
      padding: 5px;
      border-radius: 5px;
    }

    .clear-item:first-child {
      border: 1px solid #1890ff;

    }

    .payment-box {
      width: 450px;
      //padding: 10px;
      margin-top: 10px;
      //border-radius: 5px;
      //box-sizing: border-box;

    }
  }

  .form-box-last-item {
    margin-top: 10px;
    padding-left: 300px;
  }
}

.large-icon {
  /deep/ svg {
    font-size: 18px;
  }
}
</style>